module.exports = __webpack_public_path__ + "static/img/card-card-5.bde92ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-card-5.jpg
// module id = jIqd
// module chunks = 1